/* ------------------------------------------------------------------------ */
/*		File: cmpModules.tsx                                                */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpModules.d";
import "./cmpModules.css";
import IntroComponent from "../cmpIntro/cmpIntro";
import Step from "../cmpStep/cmpStep";


/* ------------------------------------------------------------------------ */

const Modules: React.FC<ICard> = (props) => {
    return (
        <div className="card_modules">
            <IntroComponent
                label={props.card.label}
            />
            <div className="card_modules_vscroll">
                {props.card.content?.map((item, index) => (
                    <Step
                        key={`step-${index}`}
                        description={item.description}
                        src={item.src}
                    />
                ))}
            </div>
            <div className="fade-overlay"></div>
        </div>
    );
};

export default Modules;